import {FunctionComponent, useContext, useEffect, useRef, useState} from 'react';
import MapContext from '../map/MapContext';
import geoSettings from '../../../config/geoSettings';
import { useAppSelector} from '../../../redux/hooks';
import SLDParser from 'geostyler-sld-parser';
import VectorSource from 'ol/source/Vector';
import {GeoJSON} from 'ol/format';
import {bbox} from 'ol/loadingstrategy';
import VectorLayer from 'ol/layer/Vector';
import {getWmsLayer, parseStyle} from '../../../functions/functionsOpenlayer';
import {Fill, Stroke, Style} from 'ol/style';

type functionProps = {
    // eslint-disable-next-line react/no-unused-prop-types
    layerName:string,
    workspace:string,
    styleName:any,
    layerKind:string,
    featureKennz:any
};

interface LayerArray {
    [key: string]: any
}

const SingleLayers: FunctionComponent<functionProps> = ({layerName, workspace, styleName, layerKind, featureKennz}) => {
    // @ts-ignore
    const {map, setMap} = useContext(MapContext);
    const [loaded, setLoaded]=useState(false);
    const refLoaded=useRef(loaded);
    const [selectedFeature, setSelectedFeature]=useState<any[]>([]);
    const [ids, setIds]=useState<any[]>([]);
    const [vLayer, setVlayer]:any=useState(null);


    const getSingleLayerStyle = (feature:any) => {

        let color='white';
        let width=1;
        const fKennz=feature.get('view_flstk');
        //  const featureArrray:any[]=selectedFeature;

        if (featureKennz!==null&&featureKennz.includes(fKennz)) {

            color='blue';
            width=3;
            // featureArrray.push(feature);
            // setSelectedFeature([...featureArrray]);
        }
        else if (featureKennz===null) {
            color='black';
            width=1;
        }
        return new Style({
            stroke: new Stroke({
                color: color,
                width: width
            }),
        });
    };

    const getLayerSource = () => {
       // console.log('getLayerSource');
        return new VectorSource({
            format: new GeoJSON(),
            url: function () {
                return (
                    'https://gis.dmt.de/geoserver/' + workspace + '/ows?service=WFS&version=2.0.0&request=GetFeature&typeName=' + workspace + ':' + layerName + '&outputFormat=application/json&srsname=EPSG:4326&maxFeatures=15'
                );
            },
            strategy: bbox
        });
    };

    const createVectorLayer = (layerSource: any, layerId: any) => {
     //   console.log('create Layer');
        const vectorLayer = new VectorLayer({
            source: layerSource,
            visible: true,
            style:getSingleLayerStyle,
            zIndex:2000000
        });
        vectorLayer.set('id', layerId);
        vectorLayer.set('type', 'vector');
        return vectorLayer;
    };

    const addSingleWFSLayer = async () => {
        const layerId = layerName.toLowerCase();
        const layerSource = getLayerSource();
        const vectorLayer = createVectorLayer(layerSource,  layerId );
        map.addLayer(vectorLayer);
        setMap(map);
        setVlayer(vectorLayer);
        return vectorLayer;
    };


    // }
    const createSimpleLayerWithConfigs = async () => {
        switch (layerKind) {
            case 'vectorData':
                await addSingleWFSLayer();
                break;
        }
        return true;
    };
    
    const sortAndSetSelectedFeature=()=>{
      //  console.log(vLayer);
        const features:[]=vLayer.getSource().getFeatures();
        for (let i=0; i<features.length; i++) {
            const f:any=features[i];
            const fKennz=f.get('view_flstk');
            const featureArrray:any[]=selectedFeature;
            if (featureKennz!==null&&featureKennz.includes(fKennz)) {
                featureArrray.push(f);
                setSelectedFeature([...featureArrray]);
            }
        }
    };

    useEffect(()=>{
        if (!vLayer || Object.keys(vLayer).length === 0|| vLayer===null) return;
        setTimeout(function() {
           // console.log(vLayer);
            sortAndSetSelectedFeature();
        },2000);
    },[vLayer]);

    useEffect(()=>{
        if (featureKennz&&featureKennz.length===1&&selectedFeature.length===1) {
            // @ts-ignore
            const extent = selectedFeature[0].getGeometry().getExtent();
            map.getView().fit(extent); 
        }
   //     console.log(selectedFeature);
    },[selectedFeature]);

    useEffect(() => {
        if (!map || Object.keys(map).length === 0) return;
        if ((featureKennz&&featureKennz.length>0||featureKennz==null)&&!refLoaded.current) {
        //    console.log('load layer', refLoaded.current);
            setLoaded(true);
            refLoaded.current=true;
            createSimpleLayerWithConfigs().then(r => console.log('layer loaded'));
        }
        if (refLoaded.current) {
            if (!vLayer || Object.keys(vLayer).length === 0|| vLayer===null) return;
            sortAndSetSelectedFeature();
        }
//console.log(featureKennz)
    }, [map,featureKennz]);

    useEffect(() => {
    //    console.log('load Singlelayer')
    }, []);

    return null;

};
export default SingleLayers;